var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Uploader"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-uploader', {
          model: {
            value: _vm.basicUsageFile,
            callback: function callback($$v) {
              _vm.basicUsageFile = $$v;
            },
            expression: "basicUsageFile"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Model as array"
    }
  }, [_c('a-uploader', {
    model: {
      value: _vm.modelAsArrayFiles,
      callback: function callback($$v) {
        _vm.modelAsArrayFiles = $$v;
      },
      expression: "modelAsArrayFiles"
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Accept attr support (e.g. .xlsx, .xls)"
    }
  }, [_c('a-uploader', {
    attrs: {
      "accept": ".xlsx, .xls"
    },
    model: {
      value: _vm.acceptAttrSupportFile,
      callback: function callback($$v) {
        _vm.acceptAttrSupportFile = $$v;
      },
      expression: "acceptAttrSupportFile"
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Disabled option"
    }
  }, [_c('a-uploader', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.disabledOptionFile,
      callback: function callback($$v) {
        _vm.disabledOptionFile = $$v;
      },
      expression: "disabledOptionFile"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }